var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "prop-types", "react", "../../Teasers/TeaserSidebar/TeaserSidebar", "../../UI/TitlesElement/TitlesElement", "./ProgramSuggestion.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("prop-types"), require("react"), require("../../Teasers/TeaserSidebar/TeaserSidebar"), require("../../UI/TitlesElement/TitlesElement"), require("./ProgramSuggestion.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.propTypes, global.react, global.TeaserSidebar, global.TitlesElement, global.ProgramSuggestion);
    global.ProgramSuggestion = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _propTypes, _react, _TeaserSidebar, _TitlesElement, _ProgramSuggestion) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _TeaserSidebar = _interopRequireDefault(_TeaserSidebar);
  _TitlesElement = _interopRequireDefault(_TitlesElement);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var ProgramSuggestion = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(ProgramSuggestion, _PureComponent);

    var _super = _createSuper(ProgramSuggestion);

    function ProgramSuggestion() {
      (0, _classCallCheck2.default)(this, ProgramSuggestion);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(ProgramSuggestion, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            theme = _this$props.theme,
            title = _this$props.title,
            titleLevel = _this$props.titleLevel,
            teasers = _this$props.teasers,
            autoplay = _this$props.autoplay;

        var StyledTitleElement = _ProgramSuggestion.StyledProgramSuggestionTitle.withComponent("h".concat(titleLevel), {
          target: "e1t2q2sj0",
          label: "StyledTitleElement"
        });

        var titleElement = title ? /*#__PURE__*/_react.default.createElement(StyledTitleElement, {
          theme: theme
        }, title) : null;
        var SuggestionHeader = _ProgramSuggestion.StyledProgramSuggestionHeader;
        return /*#__PURE__*/_react.default.createElement(_ProgramSuggestion.StyledProgramSuggestion, null, /*#__PURE__*/_react.default.createElement(_ProgramSuggestion.SuggestionHeaderContainer, null, autoplay && /*#__PURE__*/_react.default.createElement(_ProgramSuggestion.SwitchWithLabel, {
          label: autoplay.label,
          onChange: autoplay.onChange,
          isChecked: autoplay.isActivated,
          id: autoplay.id
        }), /*#__PURE__*/_react.default.createElement(SuggestionHeader, null, titleElement)), /*#__PURE__*/_react.default.createElement(_ProgramSuggestion.StyledProgramSuggestionWrapper, null, teasers && teasers.map(function (teaser) {
          return /*#__PURE__*/_react.default.createElement(_TeaserSidebar.default, (0, _extends2.default)({
            theme: theme,
            key: teaser.id,
            titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
              theme: theme,
              format: "twolines",
              title: teaser.title,
              subtitle: teaser.subtitle
            })
          }, teaser));
        })));
      }
    }]);
    return ProgramSuggestion;
  }(_react.PureComponent);

  ProgramSuggestion.propTypes = {
    theme: _propTypes.default.string,
    autoplay: _propTypes.default.shape({
      id: _propTypes.default.string,
      isActivated: _propTypes.default.bool,
      label: _propTypes.default.string,
      onChange: _propTypes.default.func
    }),
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()),
    title: _propTypes.default.string.isRequired,
    titleLevel: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6])
  };
  ProgramSuggestion.defaultProps = {
    theme: '',
    autoplay: null,
    teasers: [],
    title: '',
    titleLevel: 4
  };
  var _default = ProgramSuggestion;
  _exports.default = _default;
});